module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "epi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "FMEP"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_v",
      "title": "v"
    }
  }, [_vm._v("I’ve always thought of myself as a seeker.… I am beguiled by the mystery of life.")])]), _vm._v(" "), _c('p', {
    staticClass: "FMEPC"
  }, [_c('span', {
    staticClass: "mdash"
  }, [_vm._v("—")]), _vm._v("O"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("PRAH")]), _vm._v(" W"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("INFREY")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21679962","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 69
// module chunks = 0